// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__g0LzF","requiredAsterisk":"Info_requiredAsterisk__1ZSwO"};